import styled, { css } from 'styled-components';
import { PreviewStyledProps, VideoStyledProps } from './YouTubePlayer.typed';

export const YouTubePlayer = styled.div`
  position: relative;
  background: #000000;
  border-radius: ${({ theme }) => theme.borderRadius.s};
  overflow: hidden;

  &:before {
    display: block;
    padding-bottom: 56.25%;
    content: '';
  }
`;
export const Video = styled.iframe<VideoStyledProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: all 0.5s;

  ${({ isLoaded }) =>
    isLoaded &&
    css`
      opacity: 1;
    `}
`;
export const Preview = styled.div<PreviewStyledProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${({ src }) => src}) no-repeat;
  background-size: cover;
  background-position: 50%;
`;
